const tldList = [
  // Generic TLDs (gTLD)
  "com", "net", "org", "edu", "gov", "mil", "int",

  // New gTLDs (most popular)
  "app", "dev", "io", "ai", "tech", "online", "site", "store", "shop",
  "blog", "news", "media", "cloud", "email", "live", "today", "world",

  // Country Code TLDs (ccTLD) - Major countries
  "us", "uk", "ca", "au", "de", "fr", "it", "es", "nl", "be", "ch",
  "at", "se", "no", "dk", "fi", "pl", "cz", "ru", "ua", "gr", "pt",
  "ie", "jp", "cn", "kr", "in", "sg", "hk", "tw", "th", "my", "id",
  "ph", "vn", "ae", "sa", "il", "tr", "za", "eg", "br", "mx", "ar",
  "cl", "co", "nz",

  // Second-level domains (common patterns)
  "co.uk", "org.uk", "gov.uk", "ac.uk",
  "co.jp", "or.jp", "ne.jp", "go.jp",
  "com.au", "net.au", "org.au", "gov.au",
  "co.nz", "net.nz", "org.nz", "govt.nz",
  "co.za", "org.za", "gov.za", "ac.za",
  "com.br", "net.br", "org.br", "gov.br",
  "com.cn", "net.cn", "org.cn", "gov.cn",
  "co.in", "net.in", "org.in", "gov.in",
  "com.mx", "org.mx", "gob.mx",
  "co.il", "org.il", "gov.il",

  // Popular new TLDs
  "xyz", "top", "club", "vip", "work", "link", "pro", "wiki",

  // Development & Tech
  "localhost", "test", "example", "invalid", // Reserved
  "local", "internal", "private", // Private use

  // Popular cloud/hosting
  "vercel.app", "netlify.app", "herokuapp.com", "azurewebsites.net",
  "firebaseapp.com", "cloudflare.net", "github.io", "gitlab.io",
  "amazonaws.com", "cloudfront.net", "pages.dev",

  // Middle East (for your region)
  "ps", "jo", "sy", "lb", "iq", "kw", "bh", "om", "qa", "ye",
  "com.sa", "net.sa", "org.sa", "edu.sa", "gov.sa",
  "net.il", "ac.il",
];

export default tldList;